






















































































































































































import { Component, Vue } from "vue-property-decorator";
import headerTitle from "@/components/headerTitle.vue";
import detailModel from "./model/detailModel.vue";
import confirmModel from "@/components/confirmModel.vue";
import { gameList } from "@/req/gameManage";
import { commodityList, serverInfo, apiInvalid } from "@/req/shopManage";
import { SHOP_STATE_LIST, SHOP_COLUMNS } from "./config";
import { apiDownShelfIsBargain } from "./service";
@Component({
  components: { headerTitle, detailModel, confirmModel },
})
export default class Home extends Vue {
  public loading = false;
  public orderNum = "";
  public username = "";
  public userBox = "";
  public sprice = "";
  public eprice = "";
  public gameId: any = "";
  public gameList: any = [];
  public serverId: any = "";
  public serverList: any = [];
  public page = 1;
  public size = 10;
  public shopStateId: any = "";
  public shopStateList = SHOP_STATE_LIST;
  public columns = SHOP_COLUMNS;
  public data: any = [];
  public isShield: any = "";
  public form = {
    server_retreated: 0,
  };
  public isShieldList: any = [
    {
      id: 2,
      name: "未屏蔽",
    },
    {
      id: 1,
      name: "已屏蔽",
    },
  ];
  public mounted() {
    this.getList();
    this.getGameList();
  }
  public async getGameList() {
    const res = await gameList({
      token: this.$fn.cookies.getToken("token"),
    });
    if (res.code == 0) {
      this.$store.state.user.gameList = res.data;
    }
  }
  // 获取游戏区服列表
  public async gameChange(val) {
    this.serverId = "";
    this.serverList = [];
    if (this.gameId == "" || this.gameId == undefined) {
      return false;
    }
    const obj = {
      token: this.$fn.cookies.getToken(),
      game_id: this.gameId,
    };
    const res = await serverInfo(obj);
    if (res.code == 0) {
      this.serverList = res.data;
    }
  }
  // 操作确认
  public async getConfirmModel(type, state, id, uid, data) {
    const $confirmModel: any = this.$refs.confirmModel;
    if (state === 1) {
      const res = await apiDownShelfIsBargain({ commodity_id: id });
      if (res.code === 0 && res.data === 1) {
        $confirmModel.show(5, 5, id, uid, data);
        return;
      }
    }
    $confirmModel.show(type, state, id, uid, data);
  }
  public async getTab() {
    const $detailModel: any = this.$refs.detailModel;
    const res = await $detailModel.show();
  }
  public change(i) {
    this.page = i;
    this.getList();
  }
  public getQuery() {
    this.page = 1;
    this.getList();
  }
  public async getList() {
    this.loading = true;
    const obj: any = {
      token: this.$fn.cookies.getToken("token"),
      id: this.orderNum || "",
      game_id: this.gameId || "",
      server_id: this.serverId || "",
      username: this.username || "",
      page: this.page,
      limit: this.size,
      uid: this.userBox,
      status: this.shopStateId || "",
      eprice: this.eprice || "",
      sprice: this.sprice || "",
      is_shield:
        this.isShield == undefined
          ? ""
          : this.isShield == 2
          ? "0"
          : this.isShield,
      ...this.form,
    };
    const res = await commodityList(obj);
    if (res.code == 0) {
      this.data = res.data;
      this.loading = false;
    }
  }
  // 点击详情
  public getEditGame(rowId) {
    this.$router.push({
      path: "/shopDetail",
      query: { id: rowId },
    });
  }
  public loseClick(id) {
    this.$Modal.confirm({
      title: "失效商品",
      content: "<p>你确定要将该商品置为失效吗？</p>",
      onOk: async () => {
        const res = await apiInvalid({
          commodity_id: id,
        });
        if (res.code === 0) {
          this.getList();
          this.$Message.success("商品失效成功");
        }
      },
    });
  }
}
